<template>
  <v-menu v-model="menuActive" :close-on-content-click="false" :nudge-width="200" offset-y transition="slide-y-transition" max-width="150">
    <template v-slot:activator="{ on }">
      <v-btn small v-on="on" icon class="btn-user" @click="hideMainMenu()">
        <v-icon small>mdi-account</v-icon>
        <span>{{ name }}</span>
        <Dialog :show="dialog.show" :icon="dialog.icon" :component="dialog.component" :title="dialog.title" :contentHeight="dialog.height" :close="closeDialog" />
      </v-btn>
    </template>
    <div class="border-wrap">
      <v-card class="mx-auto">
        <v-list dense>
          <!-- <v-list-item @click="setProfile">
            <v-list-item-title>{{ $t('menu.user.profile') }}</v-list-item-title>
          </v-list-item> -->

          <!-- <v-list-item @click="setScreen">
            <v-list-item-title>{{ $t('menu.user.screen') }}</v-list-item-title>
          </v-list-item> -->

          <!-- <v-divider></v-divider> -->

          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-title>{{ $t('common.language') }}</v-list-item-title>
            </template>
            <v-list-item v-for="(language, i) in languages" :key="i" @click="setLanguage(language.code)" link>
              <v-list-item-title v-text="language.name"></v-list-item-title>
              <v-icon small v-if="$i18n.locale === language.code">mdi-check</v-icon>
            </v-list-item>
          </v-list-group>

          <v-list-group no-action>
            <template v-slot:activator>
              <v-list-item-title>{{ $t('common.theme') }}</v-list-item-title>
            </template>
            <v-list-item v-for="(theme, i) in getThemes()" :key="i" @click="setTheme(theme.name)" link>
              <v-list-item-title v-text="theme.text"></v-list-item-title>
              <v-icon small v-if="theme.active">mdi-check</v-icon>
            </v-list-item>
          </v-list-group>

          <!-- <v-list-item @click="notificationSettings">
            <v-list-item-title>{{ $t('menu.user.alarm') }}</v-list-item-title>
          </v-list-item> -->

          <!-- BEGIN::Added.by.KWShin.2024.02.01. -->
          <v-list-item @click="changeKeepLogon">
            <v-list-item-title>{{ keepLogon ? $t('menu.user.keep.logon.off') : this.$t('menu.user.keep.logon.on') }}</v-list-item-title>
          </v-list-item>
          <!-- FINISH::Added.by.KWShin.2024.02.01. -->

          <v-list-item @click="help">
            <v-list-item-title>{{ $t('menu.user.help') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="license">
            <v-list-item-title>{{ $t('menu.user.license') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="aboutOWLens">
            <v-list-item-title>{{ $t('menu.user.about') }}</v-list-item-title>
          </v-list-item>

          <v-list-item @click="signout">
            <v-list-item-title>{{ $t('sign.out') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </div>
  </v-menu>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import bus from '@/utils/bus';
import { api } from '@/api/common/instances';
import Dialog from '../Dialog.vue';
import { PERSISTEDSTATE_KEY, STORAGE_KEY_KEEP_LOGON, STORAGE_KEY_KEEP_TOKEN } from '@/constants';

export default {
  components: {
    Dialog,
  },
  data: () => ({
    menuActive: false,
    dialog: {
      show: false,
      title: '',
      component: {},
    },
    keepLogon: false,
  }),
  computed: {
    ...mapState('common/user', ['username', 'name', 'role']),
    languages() {
      return Object.keys(this.$i18n.messages).map(lang => ({
        code: lang,
        name: this.$i18n.messages[lang]['common.localLanguageName'],
      }));
    },
  },
  methods: {
    ...mapMutations('common/auth', { resetAuth: 'reset' }),
    ...mapMutations('common/menu', { resetMenu: 'reset' }),
    // BEGIN::Added.by.KWShin.2024.07.05.
    hideMainMenu() {
      bus.$emit('toggle-main-menu', false);
    },
    // FINISH::Added.by.KWShin.2024.07.05.
    /**
     * 로그온 유지 설정/해제 기능.
     * 설정되면, localStorage에 flag를 true로 설정하고 sessionStorage의 token을 localStorage에 복사해주고
     * 해제되면, localStorage에 flag를 false로 설정하고 localStorage의 token을 제거한다.
     * Added.by.KWShin.2024.02.01.
     */
    changeKeepLogon() {
      this.keepLogon = !this.keepLogon;
      window.localStorage.setItem(STORAGE_KEY_KEEP_LOGON, this.keepLogon.toString());
      if (this.keepLogon) {
        let token = (((JSON.parse((window.sessionStorage || {}).getItem(PERSISTEDSTATE_KEY.AUTH)) || {}).common || {}).auth || {}).token;
        window.localStorage.setItem(STORAGE_KEY_KEEP_TOKEN, token);
      } else {
        window.localStorage.removeItem(STORAGE_KEY_KEEP_TOKEN);
      }
    },
    closeDialog() {
      this.dialog.show = false;
    },
    async setProfile() {
      this.dialog = {
        show: true,
        title: this.$t('menu.user.profile'),
        component: (await import('../../user/Profile.vue')).default,
      };
      this.menuActive = false;
    },
    async setScreen() {
      this.dialog = {
        show: true,
        title: this.$t('menu.user.screen'),
        component: (await import('../../user/Screen.vue')).default,
      };
      this.menuActive = false;
    },
    async signout() {
      await api.get('/logout');
      this.resetAuth();
      this.resetMenu();
      this.$router.push({ path: '/login' });
    },
    getThemes() {
      return Object.keys(this.$vuetify_theme).map(name => ({
        text: this.$t(`common.themes.${name}`),
        name,
        active: this.$vuetify_theme[name],
      }));
    },
    setLanguage(language) {
      api.put(`/prefer/users/${this.username}/languages/${language}`);
      this.$store.dispatch('common/user/setLanguage', language);
      this.$i18n.locale = language;
      this.$vuetify.lang.current = language;
      document.documentElement.setAttribute('lang', language);
      this.menuActive = false;
    },
    setTheme(theme) {
      api.put(`/prefer/users/${this.username}/themes/${theme}`);
      this.$store.dispatch('common/user/setTheme', theme);
      Object.keys(this.$vuetify.theme.defaults).forEach(item => {
        this.$vuetify.theme[item] = item == theme;
        this.$vuetify_theme[item] = item == theme;
      });
      this.menuActive = false;
    },
    async notificationSettings() {
      this.dialog = {
        show: true,
        title: this.$t('menu.user.alarm'),
        component: (await import('../../user/Alarm.vue')).default,
      };
      this.menuActive = false;
    },
    // BEGIN::Modified.by.KWShin.2022.09.16.
    // help.htm 파일 수정이 완료되면 윗부분을 막고 밑부분을 열것.
    //-----------------------------------------------------------
    // v-card 컴포넌트 내에 도움말 파일을 연다.
    // 스크롤도 불편하고 바탕색이 검정이거나 흰색이어서 설정 맞추기가 번거롭다.
    // 또한, 파일을 불러올리고 나면 다른 요소들의 style이 영향을 받아 화면이 깨진다.
    //-----------------------------------------------------------
    // async help() {
    //   this.dialog = {
    //     show: true,
    //     title: this.$t('menu.user.help'),
    //     component: (await import('../../user/Help.vue')).default,
    //   };
    //   this.menuActive = false;
    // },
    //-----------------------------------------------------------
    // 새로운 창에 도움말 파일을 연다.
    //-----------------------------------------------------------
    async help() {
      // BEGIN::Modified.by.HJSeo.2026.07.29. 새 매뉴얼(help-new.htm)을 열고, 관리자(ROLE_ADMIN)면 8장 노출용 admin 플래그를 전달한다.
      const adminParam = this.role === 'ROLE_ADMIN' ? '?admin=1' : '';
      const url = `${process.env.BASE_URL}help-new.htm${adminParam}`;
      // FINISH::Modified.by.HJSeo.2026.07.29.
      window.open(url, '_blank', 'left=400,width=1200,height=920');
      this.menuActive = false;
    },
    //-----------------------------------------------------------
    // FINISH::Modified.by.KWShin.2022.09.16.
    async license() {
      this.dialog = {
        show: true,
        icon: 'mdi-certificate',
        height: 314,
        title: this.$t('menu.user.license'),
        component: (await import('../../user/License.vue')).default,
      };
      this.menuActive = false;
    },
    async aboutOWLens() {
      this.dialog = {
        show: true,
        icon: 'mdi-bullseye',
        height: 410,
        title: this.$t('menu.user.about'),
        component: (await import('../../user/About.vue')).default,
      };
      this.menuActive = false;
    },
  },
  mounted() {
    // BEGIN::Added.by.KWShin.2024.02.01.
    this.keepLogon = window.localStorage.getItem(STORAGE_KEY_KEEP_LOGON) === 'true' ? true : false;
    // FINISH::Added.by.KWShin.2024.02.01.
  },
};
</script>
